module.exports = __webpack_public_path__ + "img/elevated-alert-button.6d7efccb.svg";